import { AbyssTheme as themeConfiguration } from '@src/app/browser';
import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Grid } from '@uhg-abyss/web/ui/Grid';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Skeleton as AbyssSkeleton } from '@uhg-abyss/web/ui/Skeleton';
import { motion } from 'framer-motion';
import React from 'react';

/**
 * Skeleton
 *
 * @returns {Element}
 * @constructor
 */
export function Skeleton() {
  return (
    <ErrorHandler location="src/pages/private/Analysis/EidSearch/components/Form/components/Skeleton/Skeleton.jsx">
      <motion.div
        animate="open"
        initial={{ opacity: 0 }}
        variants={{
          closed: { opacity: 0 },
          open: { opacity: 1 },
        }}
      >
        <Grid>
          <Grid.Col
            span={{
              xs: '100%',
            }}
          >
            <Layout.Stack alignItems="left" grow>
              <AbyssSkeleton data-testid="form-skeleton" height={themeConfiguration?.theme?.space?.lg} width="75%" />
              <AbyssSkeleton data-testid="form-skeleton" height={themeConfiguration?.theme?.space?.xl} width="100%" />
            </Layout.Stack>
          </Grid.Col>
        </Grid>
      </motion.div>
    </ErrorHandler>
  );
}
